import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import MuiDialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { EnrollmentFileUploader as FileUploader, Label } from "../formInputs";
import { Grid } from "@material-ui/core";
import { useActions } from "../../actions";
import * as Actions from "../../actions/account";
import * as ClientActions from "../../actions/client";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import { Formik } from "formik";
import { cashStreamSlug } from "../../constants";
import moment from "moment";

const styles: any = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: "absolute",
        right: '10px',
        top: '16px',
        color: theme.palette.grey[500],
    },
});

const DialogTitle: any = withStyles(styles)((props: any) => {
    const { children, classes, onClose, ...other } = props;
    return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="body1" component="strong">{children}</Typography>
                {onClose ? (
                        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                            <CloseIcon/>
                        </IconButton>
                ) : null}
            </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const UploadProposalPopUp = (props: {
    open: boolean,
    setUploadProposalPopUp: Function,
    enrollmentId: string,
    clientId: number,
    agentId: number,
    clientUserId?: string,
    refreshList: Function,
    client: any,
    proposalUpdate?: boolean,
    currentDocument: any,
    clientPolicyId: string,
    actionId?: number
}) => {
    const {
        open,
        setUploadProposalPopUp,
        enrollmentId,
        clientId,
        agentId,
        refreshList,
        proposalUpdate,
        currentDocument,
        clientPolicyId,
        actionId
    } = props;
    const { getClient } = useActions(ClientActions);
    const [fileName, setFileName] = React.useState(""); // client proposal
    const [fileName2, setFileName2] = React.useState(""); // client illustration
    const accountActions = useActions(Actions);
    const [cashStream, setCashStream] = React.useState(false); // cash stream strategy
    const [employerOnly, setEmployerOnly] = React.useState(false); // employer only
    const [issuedCon, setIssueCon] = React.useState(true);
    const {client} = props;
    const clientPolicy = client && client.clientPolicies && client.clientPolicies.length > 0 && client.clientPolicies[0];
    const isIllustration = currentDocument.name === "Carrier Illustration";

    React.useEffect(() => {
        if (clientPolicy && clientPolicy.strategy && clientPolicy.strategy.slug === cashStreamSlug) {
            setCashStream(true);
        }
        if (clientPolicy && clientPolicy.company && clientPolicy.company.contributionType &&
                clientPolicy.company.contributionType === "EMPLOYER_ONLY") {
            setEmployerOnly(true);
        }
    }, [client]);

    React.useEffect(()=>{
        if(cashStream || employerOnly){
            setIssueCon(false);
        }
    },[cashStream, employerOnly])
    const handleClose = () => {
        setUploadProposalPopUp(false);
    };

    const handleUploadProposal = async (values:any, setSubmitting:Function) => {
        if(proposalUpdate){
            await accountActions.replaceClientDocument({
                fileName,
                name: currentDocument && currentDocument.name,
                clientPolicyId: clientPolicy.id,
                clientId
            }, isIllustration);
        }
        await getClient(clientId, clientPolicyId);
        setSubmitting(false);
        handleClose();
        if (typeof refreshList === "function") {
            refreshList();
        }
    };

    const initialValues = {
        issuedContribution:  '',
        deathBenefit :  '',
        employerContribution: ''
    };

    console.log(currentDocument," setCurrentDocument")
    return (
            <Dialog fullWidth={true} maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
                <DialogTitle className="closeSvg" id="customized-dialog-title" onClose={handleClose}>
                    Upload New Client Documents { proposalUpdate && (currentDocument && currentDocument.name)}
                </DialogTitle>
                <Formik
                        initialValues={initialValues}
                        enableReinitialize={true}
                        validateOnChange={true}
                        onSubmit={(values, { setSubmitting }) => {
                            handleUploadProposal(values, setSubmitting);
                        }}
                >
                    {({
                          handleSubmit,
                          isSubmitting,
                      }) => (
                            <form onSubmit={handleSubmit}>
                                <DialogContent dividers>
                                    <>
                                        <Grid container spacing={2} justify="center">
                                            <Grid item xs={12} md={6} className="textCenter">
                                                <Typography variant="subtitle2" component="strong" className="floatLeft w100 mb0">Upload Client Document</Typography>
                                                <FileUploader
                                                        exactFileName={`${proposalUpdate && (currentDocument && currentDocument.name)}`}
                                                        dirName={enrollmentId}
                                                        dirType={"documents"}
                                                        fileType={"image/jpeg,image/gif,image/png,application/pdf,.pdf"}
                                                        content={"Drop files here or click to upload"}
                                                        onFinish={async (publicUrl: string, name: string) => {
                                                            setFileName(name);
                                                        }}
                                                        textWithIcon={"Upload Document"}
                                                        iconOnly={true}
                                                />
                                                {fileName !== '' &&
                                                        <>
                                                            {fileName}
                                                            <DeleteForeverIcon
                                                                    onClick={() => setFileName("")}
                                                                    color="error"
                                                                    style={{ verticalAlign: "bottom", cursor: "pointer" }}
                                                            />
                                                        </>
                                                }
                                            </Grid>

                                            <Grid item xs={12} className="textRight">
                                                {!proposalUpdate && <Button
                                                        variant="contained"
                                                        color="primary"
                                                        className="floatRight"
                                                        disabled={isSubmitting || (fileName == "" || fileName2 == "")}
                                                        type={"submit"}
                                                >
                                                    Send For Approval
                                                </Button>
                                                }
                                                {(proposalUpdate && fileName !== '') &&
                                                        <Button
                                                                variant="contained"
                                                                color="primary"
                                                                className="floatRight"
                                                                disabled={isSubmitting}
                                                                type={"submit"}
                                                        >
                                                            Replace Document
                                                        </Button>
                                                }
                                            </Grid>
                                        </Grid>

                                    </>
                                </DialogContent>
                            </form>
                    )}
                </Formik>
            </Dialog>
    );
}

export default UploadProposalPopUp;
